import { createClient } from "@supabase/supabase-js";

// Oscar - Supabase backend
// anon key is safe in frontend code; it only allows what Row Level Security permits.
const SUPABASE_URL = "https://jbbirqlljgqbuwjsmars.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpiYmlycWxsamdxYnV3anNtYXJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEzNjU4NDQsImV4cCI6MjA5Njk0MTg0NH0.fkIPa2jcHP_GrhwVM6qSX4VW12SV_EbrCApqCDqwouM";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // Keep the user signed in across page refreshes / pull-to-refresh.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "oscar-radar-auth"
  }
});

// ---- Distance fuzzing for privacy ----
// Snap coordinates to a coarse grid (~0.4 mi cells) so exact location is never exposed.
const FUZZ_DEG = 0.006; // ~0.41 mi latitude
export function fuzz(lat, lon) {
  const fl = Math.round(lat / FUZZ_DEG) * FUZZ_DEG;
  const fo = Math.round(lon / FUZZ_DEG) * FUZZ_DEG;
  // deterministic tiny jitter per cell so blips don't all stack on grid points
  const j = (Math.sin(fl * 1000 + fo * 1000) + 1) / 2;
  return { lat: fl + (j - 0.5) * FUZZ_DEG * 0.5, lon: fo + (j - 0.5) * FUZZ_DEG * 0.5 };
}

// Haversine distance in miles
export function milesBetween(la1, lo1, la2, lo2) {
  const R = 3958.8, toR = Math.PI / 180;
  const dLa = (la2 - la1) * toR, dLo = (lo2 - lo1) * toR;
  const a = Math.sin(dLa / 2) ** 2 +
    Math.cos(la1 * toR) * Math.cos(la2 * toR) * Math.sin(dLo / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// Bearing in degrees (0=N) from point 1 to point 2
export function bearingBetween(la1, lo1, la2, lo2) {
  const toR = Math.PI / 180, toD = 180 / Math.PI;
  const y = Math.sin((lo2 - lo1) * toR) * Math.cos(la2 * toR);
  const x = Math.cos(la1 * toR) * Math.sin(la2 * toR) -
    Math.sin(la1 * toR) * Math.cos(la2 * toR) * Math.cos((lo2 - lo1) * toR);
  return (Math.atan2(y, x) * toD + 360) % 360;
}
